import { useState } from 'react';
import CircularMenuItem from './CircularMenuItem';
import MenuStyle from "../styles/circular-menu.module.css"

function CircularMenu({ pages }) {
    // state variables

    const [isOpen, setIsOpen] = useState(false);

    // ------------------------------

    // handle set isOpen

    const handleSetIsOpen = () => {
      setIsOpen(prevBool => !prevBool);
    };

    // ------------------------------

    return (
        <div className={MenuStyle.circularMenu}>
        <div className={MenuStyle.menuButton} onClick={handleSetIsOpen}>
          {/* {isOpen ? <CloseCircularMenu style={MenuStyle}/> : <CircularMenuIcon style={MenuStyle}/>} */}
        </div>
        {
          pages.map(([page, bg, color,image,link], index) => (
            <CircularMenuItem
                key={page}
                page={page}
                bg={bg}
                color={color}
                image ={image}
                link = {link}
                rotation={(360 / pages.length) * index}
                menuIsOpen={isOpen}
                transitionDelay={index * 75}
                style={MenuStyle}
            />
          ))
        }
      </div>
      // </div>
    );
}

export default CircularMenu;